<template>
  <div>
    <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button>
    </el-radio-group> -->
    <el-menu
      :default-active="defaultactive"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
    >
      <el-submenu :index="item1.Menu_ID" v-for="item1 of MenuList" :key="item1.Menu_ID">
        <template slot="title">
          <Icon :custom="generateClassName(item1.Menu_Icon)" size="24" color="#FE8A33"/>
          <span slot="title">{{item1.Menu_Name}}</span>
        </template>
        <el-submenu :index="item2.Menu_ID" v-for="item2 of item1.subsetlist" :key="item2.Menu_ID">
          <span slot="title">{{item2.Menu_Name}}</span>
          <el-menu-item :index="item3.Menu_ID" v-for="item3 of item2.subsetlist" :key="item3.Menu_ID" @click="handleSelect(item1.Menu_Name,item2.Menu_Name,item3)">{{item3.Menu_Name}}</el-menu-item>
        </el-submenu>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>

export default {
  name: 'menu',
  props: {
    isCollapse: Boolean,
    MenuList: Array,
    defaultactive: String
  },
  methods: {
    handleSelect (path1, path2, fc) {
      this.$emit('MenuSelectHandle', path1, path2, fc.Menu_Name, fc.Menu_ID)
      const info = {
        path1: path1,
        path2: path2,
        Menu_ID: fc.Menu_ID,
        Menu_Name: fc.Menu_Name,
        Menu_UrlName: fc.Menu_UrlName,
        active: true
      }
      let MenuList = []
      if (this.$store.state.TopMenu !== null) {
        MenuList = this.$store.state.TopMenu
      }
      let IsExist = false
      if (MenuList !== null) {
        MenuList.forEach(item => {
          if (item.Menu_ID === fc.Menu_ID) {
            IsExist = true
            item.active = true
          } else {
            item.active = false
          }
        })
      }
      if (!IsExist) {
        MenuList.push(info)
      }
      this.$store.commit('setTopMenu', MenuList)
      if (fc.Menu_UrlName !== '' || fc.Menu_UrlName !== null) {
        this.$router.push({ name: fc.Menu_UrlName })
      }
    },
    // 动态获取class
    generateClassName (name) {
      return 'iconfont ' + name
    }
  }
}
</script>

<style>
@import '../../../assets/custom/iconfont.css';

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>
